import React from "react";

export function BuilderPage() {
    // return <Builder />;
    return <h1>I am under process</h1>
}
